import PropTypes from 'prop-types';
import React, { Component } from 'react';
import entityComposition from '../classes/entityComposition';
import Version from './version';
const shouldDisplay = props => props.webInfo.build !== null && props.serverInfo.build !== null;
class VersionDisplay extends Component {
  componentDidMount() {
    const initServerInfo = this.props.infoActions.initServerInfo;
    if (initServerInfo) {
      initServerInfo();
    }
  }
  render() {
    const _this$props = this.props,
      info = _this$props.info,
      style = _this$props.style;
    return shouldDisplay(info) ? /*#__PURE__*/React.createElement("div", {
      style: style
    }, /*#__PURE__*/React.createElement(Version, {
      name: "Web",
      build: info.webInfo.build,
      tag: info.webInfo.tag,
      version: info.webInfo.version,
      env: info.webInfo.env
    }), /*#__PURE__*/React.createElement(Version, {
      append: true,
      name: "Server",
      build: info.serverInfo.build,
      tag: info.serverInfo.tag,
      version: info.serverInfo.version,
      env: info.webInfo.env
    })) : null;
  }
}
const infoShape = {
  build: PropTypes.string,
  tag: PropTypes.string,
  version: PropTypes.string
};
VersionDisplay.propTypes = {
  info: PropTypes.shape({
    webInfo: PropTypes.shape(infoShape),
    serverInfo: PropTypes.shape(infoShape)
  }).isRequired,
  infoActions: PropTypes.shape({
    initServerInfo: PropTypes.func
  }),
  style: PropTypes.shape({
    paddingTop: PropTypes.string
  })
};
VersionDisplay.defaultProps = {
  style: {},
  infoActions: {}
};
export { VersionDisplay as TestVersionDisplay };
export default entityComposition(VersionDisplay, ['info']);